export function getCurrentDate(separator='-') {
    let newDate = new Date()   
    const year = newDate.toLocaleDateString("pl-PL", { year: "numeric" });
    const month = newDate.toLocaleDateString("pl-PL", { month: "2-digit" });
    const day = newDate.toLocaleDateString("pl-PL", { day: "2-digit" });

    const date = `${year}${separator}${month}${separator}${day}`;
    return date;
}

export function getCurrentMonth() {
    return new Date().toLocaleDateString("pl-PL", { month: "long" });
}

export function getCurrentYear() {
    return new Date().toLocaleDateString("pl-PL", { year: "numeric" });
}